import React from 'react';
import { FiList, FiGrid, FiPieChart, FiCalendar } from 'react-icons/fi';

const VIEWS = [
  { id: 'kanban', name: 'Kanban Board', icon: FiGrid },
  { id: 'list', name: 'List View', icon: FiList },
  { id: 'stats', name: 'Statistics', icon: FiPieChart },
  { id: 'calendar', name: 'Calendar', icon: FiCalendar },
];

/**
 * Horizontal tab navigation for the Applications page.
 * Replaces the old left ApplicationSidebar so the content area can use
 * the full page width (especially helpful for the analytics dashboard).
 */
const ApplicationViewTabs = ({ activeView, setActiveView }) => {
  return (
    <div
      role="tablist"
      aria-label="Application views"
      className="flex items-center gap-1 border-b border-gray-200 mb-4 overflow-x-auto -mx-1 px-1"
    >
      {VIEWS.map(({ id, name, icon: Icon }) => {
        const isActive = activeView === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => setActiveView(id)}
            className={`group inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 ${
              isActive
                ? 'border-primary-600 text-primary-700'
                : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300'
            }`}
          >
            <Icon
              className={`h-4 w-4 ${
                isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-600'
              }`}
            />
            {name}
          </button>
        );
      })}
    </div>
  );
};

export default ApplicationViewTabs;
